/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Nav } from "react-bootstrap";
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import Select from "../../common-components/select/Select.jsx";
import { dataUploadOptions } from "../CodeConversion/conversion-options";
import { useDispatch, useSelector } from "react-redux";
import { downloadZip, fixVulnerabilities, initializeWebSocket, upgrade, 
  uploadCode, uploadRepoCode
} from "../../state/reducers/versionUpgrade.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./VersionUpgrade.scss";
import { 
  faCheck, faCircleExclamation,
  faNetworkWired, faCode, faLevelUpAlt, faShieldAlt, faVial } from "@fortawesome/free-solid-svg-icons";
import { setInlineLoader } from "../../state/reducers/common.js";
import { toast } from "react-toastify";

const languageOptions = [
  {
    value: "java",
    label: "Java",
    frameworks: [
      {
        value: "springboot",
        label: "Springboot",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ],
        buildOptions: [
          {
            value: "mvn clean package",
            label: "mvn clean package"
          },
          {
            value: "mvn clean install",
            label: "mvn clean install"
          }
        ]
      }
    ],
    versions: [
      {
        value: "3",
        label: "3"
      },
      {
        value: "4",
        label: "4"
      }
    ]
  },
  {
    value: "python",
    label: "Python",
    frameworks: [
      {
        value: "flask",
        label: "Flask",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ]
      },
      {
        value: "fastapi",
        label: "FastAPI",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ]
      }
    ],
    versions: [
      {
        value: "3",
        label: "3"
      },
      {
        value: "4",
        label: "4"
      }
    ]
  },
  {
    value: "javascript",
    label: "JavaScript",
    frameworks: [
      {
        value: "react",
        label: "React",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ]
      },
      {
        value: "angular",
        label: "Angular",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ]
      }
    ],
    versions: [
      {
        value: "3",
        label: "3"
      },
      {
        value: "4",
        label: "4"
      }
    ]
  },
  {
    value: "c#",
    label: "C#",
    frameworks: [
      {
        value: ".net",
        label: ".NET",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ]
      },
      {
        value: ".net mvc",
        label: ".NET MVC",
        versions: [
          {
            value: "3",
            label: "3"
          },
          {
            value: "4",
            label: "4"
          }
        ]
      }
    ],
    versions: [
      {
        value: "3",
        label: "3"
      },
      {
        value: "4",
        label: "4"
      }
    ]
  },
]

function VersionUpgrade() {
  const [language, setLanguage] = useState("");
  const [framework, setFramework] = useState("");
  const [sourceLanguageVersion, setSourceLanguageVersion] = useState("");
  const [targetLanguageVersion, setTargetLanguageVersion] = useState("");
  const [sourceFrameworkVersion, setSourceFrameworkVersion] = useState("");
  const [targetFrameworkVersion, setTargetFrameworkVersion] = useState("");
  const [buildOptions, setBuildOptions] = useState("");
  const [uploadOption, setUploadOption] = useState("");
  const [file, setFile] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [githubUrl, setGithubUrl] = useState("");
  const [value, setValue] = useState(5);
  const [errors, setErrors] = useState(undefined);
  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState([
    {
      key: "step1",
      name: "Source Code",
      status: "pending",
      icon: faNetworkWired
    },
    {
      key: "step2",
      name: "Source Options",
      status: "pending",
      icon: faCode
    },
    {
      key: "step3",
      name: "Upgrade",
      status: "pending",
      icon: faLevelUpAlt
    },
    {
      key: "step4",
      name: "Security Vulnerabilities",
      status: "pending",
      icon: faShieldAlt
    },
    {
      key: "step5",
      name: "Unit Testing",
      status: "pending",
      icon: faVial
    }
  ])

  const upgradeStatus = useSelector((state) => state.versionUpgrade.status)
  const upgradeData = useSelector((state) => state.versionUpgrade.data)
  const vulnerabilityData = useSelector((state) => state.versionUpgrade.vulnerabilityData)
  // const upgradeData = ["Hello", "Completed the upgradation process", "{\"event\": \"upgraded project download button\"}", "Failed processing the data", "Upgrade Process", "{\"event\": \"security report download button\"}"]
  // const vulnerabilityData = ["Hello", "Completed the upgradation process", "{\"event\": \"upgraded project download button\"}", "Failed processing the data", "Upgrade Process", "{\"event\": \"security report download button\"}"]
  const clonePath = useSelector((state) => state.versionUpgrade.clonePath)
  const upgradeDetails = useSelector((state) => state.versionUpgrade.upgradeDetails)
  const vulnerabilityDetails = useSelector((state) => state.versionUpgrade.fixVulnerabilityDetails)
  const upgradeDone = useSelector((state) => state.versionUpgrade.upgradeDone)


  const dispatch = useDispatch()

  const handleSliderChange = (e) => {
    setValue(Number(e.target.value));
  };

  useEffect(() => {
    console.log("Clone Path: ", clonePath)
    if(clonePath){
      const updatedStep = steps.map(step => {
        if(step.key === "step1"){
          return {
            key: "step1",
            name: "Source Options",
            status: "completed",
            icon: faNetworkWired
          }
        } else {
          return step
        }
      })
      setSteps(updatedStep)
      setActiveStep(1)
    }
  }, [clonePath])

  const handleFileChange = (event) => {
    const files = event.target.files;
    setFile(files);
    console.log("Files: ", files)
    const validFileContents = [];
    Array.from(files).forEach(file => {
      const reader = new FileReader();
      reader.onload = function(e) {
        validFileContents.push({
          name: file.name,
          content: e.target.result
        });
        if (validFileContents.length === files.length) {
          setFileContent(validFileContents);
        }
      };
      reader.readAsText(file);
    });
  };

  const handleUpgrade = () => {
    if(validateFields()){
      dispatch(setInlineLoader(true))
      const websocketURL = "wss://code-crafter-api-v1-677861082546.us-central1.run.app/ws/1234567";
      dispatch(initializeWebSocket(websocketURL));
    }
  }

  const handleVulnerabilities = () => {
    dispatch(setInlineLoader(true))
    const websocketURL = "wss://code-crafter-api-v1-677861082546.us-central1.run.app/ws/1234567";
    dispatch(initializeWebSocket(websocketURL));
  }

  useEffect(() => {
    console.log("State update: ", upgradeStatus)
    if (upgradeStatus === "connected" && !upgradeDone) {
      const timeoutId = setTimeout(() => {
        dispatch(
          upgrade({
            zip_file_path: clonePath,
            max_retries: value,
            build_option: buildOptions,
            session_id: "1234567",
          })
        );
      }, 20000); // 10 seconds delay
      
      return () => clearTimeout(timeoutId);
    } else if(upgradeStatus === "connected" && upgradeDone){
      const timeoutId = setTimeout(() => {
        dispatch(fixVulnerabilities({
          session_id: 1234567,
          security_project_path: upgradeDetails.security_project_path,
          secure_versions: upgradeDetails.secure_versions,
          build_option: "mvn clean package",
          previous_report: upgradeDetails.previous_report,
          security_workspace: upgradeDetails.security_workspace_path
        }))
      }, 10000); // 10 seconds delay
      
      return () => clearTimeout(timeoutId);
    } else if(upgradeStatus === "closed" || upgradeStatus === "error") {
      handleUpgrade()
    }
  }, [upgradeStatus])

  const handleUploadCode = () => {
    // setActiveStep(1)
    if(uploadOption == "github-link"){
      dispatch(uploadRepoCode({
        repo_url: githubUrl
      }))
    } else {
      dispatch(uploadCode({
        source_files: file
      }))
    }
    
  }

  const validateFields = () => {
    const newErrors = {};
    // if (!uploadOption) newErrors.uploadOption = "File source option is required";
    // if (!language) newErrors.language = "Language is required";
    // if (!sourceLanguageVersion) newErrors.sourceLanguageVersion = "Source Language Version is required";
    // if (!targetLanguageVersion) newErrors.targetLanguageVersion = "Target Language Version is required";
    // if (uploadOption != "github" && !file) newErrors.file = "File upload is required";
    // if (uploadOption == "github" && !githubUrl) newErrors.file = "Github URL is required";
    // if (framework == "springboot" && !buildOptions) newErrors.buildOptions = "Build Options is required"

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetFields = () => {
    setFile("")
    setFileContent("")
    setBuildOptions("")
    setFramework("")
    setGithubUrl("")
    setLanguage("")
    setSourceFrameworkVersion("")
    setSourceLanguageVersion("")
    setTargetFrameworkVersion("")
    setTargetLanguageVersion("")
    setValue("")
    setUploadOption("")
  }

  console.log("Files: ", file, fileContent)

  const handleStepChange = (stepIndex) => {
    // Only allow navigation to completed or current steps
    if (steps[stepIndex].status === "completed" || stepIndex === activeStep) {
      setActiveStep(stepIndex);
    }
  };

  const handleDownload = async (downloadUrl) => {

    if (!downloadUrl) {
      toast.error("No download URL found. Please retry the conversion.");
      return;
    }

    try {
      const filename = downloadUrl.split("/").pop() || "converted_application.zip";

      await dispatch(downloadZip({downloadUrl, filename}));
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download the file.");
    }
  };


  return (
    <div className="page-wrapper version-upgrade-page">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Version Upgrade</h2>
            <div className="version-upgrade-wrapper">
              <Row>
                <Col sm={12}>
                  <div className="custom-stepper">
                    <Nav 
                      variant="pills" 
                      className="stepper-nav-vu"
                      activeKey={steps[activeStep].key}
                    >
                      {steps.map((item, i) => (
                        <React.Fragment key={item.key}>
                          <div className="stepper-item-vu">
                            <Nav.Link 
                              eventKey={item.key}
                              onClick={() => handleStepChange(i)}
                              className={`stepper-link-vu ${
                                i === activeStep ? "active" : ""
                              }`}
                            >
                              <div className="stepper-content-vu">
                                {item.status === "inprogress" ? (
                                  <div className="stepper-icon">
                                    <FontAwesomeIcon 
                                      icon={faCircleExclamation} 
                                      className="failed-icon" 
                                    />
                                  </div>
                                ) : item.status === "completed" ? (
                                  <div className="stepper-icon-vu">
                                    <FontAwesomeIcon 
                                      icon={faCheck} 
                                      className="check-icon" 
                                    />
                                  </div>
                                ) : (
                                  <div className="stepper-icon-vu">
                                    <FontAwesomeIcon
                                      icon={item.icon}
                                      className="step-icon"
                                    />
                                  </div>
                                )}
                                <span className="step-name">{item.name}</span>
                              </div>
                            </Nav.Link>
                          </div>
                          {i < steps.length - 1 && (
                            <div className="stepper-divider">
                              <div className="arrow-right"></div>
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                    </Nav>
                  </div>
                </Col>
              </Row>
      
              {/* Content Display Area */}
              <Row className="mt-4">
                <Col>
                  <div className="step-content">
                    {
                      activeStep == 1 &&
                      <>
                        <Row className="mb-3">
                          <Col md={12}>
                            <Form.Text className="text-muted d-block mt-3 mb-3 form-text">
                              Language Options
                            </Form.Text>
                          </Col>
                          <Col md={6}>
                            <Select 
                              value={language} 
                              options={languageOptions} 
                              placeholder={"Select Language"} 
                              label="Source Language" 
                              id="source-language"
                              layoutStyle="horizontal"
                              labelColSize={4}
                              inputColSize={8} 
                              required
                              onChange={(e) => setLanguage(e.target.value)}
                              validationMsg={errors?.language}
                            />
                          </Col>
                        </Row>
                        {
                          language &&
                <Row className="mb-3">
                  <Col md={6}>
                    <Select 
                      value={sourceLanguageVersion} 
                      options={languageOptions.find(lang => lang.value === language)?.versions} 
                      placeholder={"Select Source Language Version"} 
                      label="Source Language Version" 
                      id="source-language-version"
                      layoutStyle="horizontal"
                      labelColSize={4}
                      inputColSize={8} 
                      required
                      onChange={(e) => setSourceLanguageVersion(e.target.value)}
                      validationMsg={errors?.sourceLanguageVersion}
                    />
                  </Col>
                  <Col md={6}>
                    <Select 
                      value={targetLanguageVersion} 
                      options={languageOptions.find(lang => lang.value === language)?.versions} 
                      placeholder={"Select Target Language Version"} 
                      label="Target Language Version" 
                      id="target-language-version" 
                      onChange={(e) => setTargetLanguageVersion(e.target.value)}
                      layoutStyle="horizontal"
                      labelColSize={4}
                      inputColSize={8} 
                      required
                      validationMsg={errors?.targetLanguageVersion}
                    />
                  </Col>
                </Row>
                        }
                        {
                          language && <Row className="mb-3">
                            <Col md={12}>
                              <Form.Text className="text-muted d-block mt-3 mb-3 form-text">
                      Framework Options
                              </Form.Text>
                            </Col>
                            <Col md={6}>
                              <Select 
                                value={framework} 
                                options={languageOptions.find(lang => lang.value === language)?.frameworks} 
                                placeholder={"Select Framework"} 
                                label="Source Framework"  
                                id="framework" 
                                onChange={(e) => setFramework(e.target.value)}
                                layoutStyle="horizontal"
                                labelColSize={4}
                                inputColSize={8}
                              />
                            </Col>
                            {
                              framework == "springboot" && <Col md={6}>
                                <Select 
                                  value={buildOptions} 
                                  options={languageOptions.find(lang => lang.value === language)?.frameworks.find(fw => fw.value == framework)?.buildOptions} 
                                  placeholder={"Select Build Options"} 
                                  label="Build Options" 
                                  id="build-options" 
                                  onChange={(e) => setBuildOptions(e.target.value)}
                                  layoutStyle="horizontal"
                                  labelColSize={4}
                                  inputColSize={8} 
                                  required
                                  validationMsg={errors?.buildOptions}
                                />
                              </Col>
                            }
                          </Row>
                        }
                        {
                          language && framework && <Row className="mb-3">
                            <Col md={6}>
                              <Select 
                                value={sourceFrameworkVersion} 
                                options={languageOptions.find(lang => lang.value === language)?.frameworks.find(fw => fw.value == framework)?.versions} 
                                placeholder={"Select Source Framework Version"} 
                                label="Source Framework Version" 
                                id="source-framework-version"
                                layoutStyle="horizontal"
                                labelColSize={4}
                                inputColSize={8}
                                onChange={(e) => setSourceFrameworkVersion(e.target.value)}
                              />
                            </Col>
                            <Col md={6}>
                              <Select 
                                value={targetFrameworkVersion} 
                                options={languageOptions.find(lang => lang.value === language)?.frameworks.find(fw => fw.value == framework)?.versions} 
                                placeholder={"Select Target Framework Version"} 
                                label="Target Framework Version" 
                                id="target-framework-version" 
                                onChange={(e) => setTargetFrameworkVersion(e.target.value)}
                                layoutStyle="horizontal"
                                labelColSize={4}
                                inputColSize={8}
                              />
                            </Col>
                          </Row>
                        }
                        <Row className="mt-5">
                          <Col className="text-end">
                            <CustomButton className="me-3" label="Start Upgrade" onClick={() => {
                              handleUpgrade()
                              const updatedStep = steps.map(step => {
                                if(step.key === "step2"){
                                  return {
                                    ...step,
                                    status: "completed",
                                  }
                                } else {
                                  return step
                                }
                              })
                              setSteps(updatedStep)
                              setActiveStep(2)
                            }} />
                            <CustomButton className="me-3" label="Reset" onClick={resetFields} />
                          </Col>
                        </Row>
                      </>
                    }
                    {
                      activeStep == 0 &&
                      <>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Select 
                              value={uploadOption} 
                              options={dataUploadOptions} 
                              placeholder={"Select upload method"} 
                              label="File Source Options" 
                              id="upload-method" 
                              onChange={(e) => {
                                setUploadOption(e.target.value)}}
                              layoutStyle="horizontal"
                              labelColSize={4}
                              inputColSize={8} 
                              required
                              validationMsg={errors?.uploadOption}
                            />
                          </Col>
                          <Col xs={6}>
                            <InputField 
                              id="iterations" 
                              label="Feedback Iterations"
                              value={value} 
                              onChange={(e) => {
                                handleSliderChange(e)
                              }}
                              layoutStyle="horizontal"
                              labelColSize={4}
                              inputColSize={8} 
                            />
                          </Col>
                          <Col md={6}>
                            {uploadOption === "file-upload" && 
                    <div>
                      <InputField
                        id="files" 
                        type="file" 
                        label="Upload Files" 
                        onChange={handleFileChange}
                        layoutStyle="horizontal"
                        labelColSize={4}
                        inputColSize={8}
                        required
                        validationMsg={errors?.file}
                        accept=".zip" // Only allows ZIP files
                      />
                    </div>
                            }
                            {
                              uploadOption === "github-link" &&
                    <InputField 
                      id="github-link" 
                      label="GitHub Url"
                      value={githubUrl} 
                      onChange={(e) => setGithubUrl(e.target.value)}
                      layoutStyle="horizontal"
                      labelColSize={4}
                      inputColSize={8}
                      required
                      validationMsg={errors?.file}
                    />
                            }
                          </Col>
                        </Row>
                        <Row className="mt-5">
                          <Col className="text-end">
                            <CustomButton className="me-3" label={uploadOption === "github-link" ? "Clone Repo" :"Upload Code"} onClick={handleUploadCode} />
                          </Col>
                        </Row>
                      </>
                    }
                    {
                      activeStep == 2 &&
                      <Container className="px-4 py-3">
                        <Row>
                          {upgradeData.length > 0 ? upgradeData.map((data, index) => (
                            <Col md={12} key={index}>
                              {console.log("Data: ", data)}
                              {
                                data.includes("event") && data.includes("path") ?
                                  <>
                                    {
                                      JSON.parse(data)?.event === "upgraded project download button" &&
                                      <CustomButton label="Download Project Zip" onClick={() => handleDownload(JSON.parse(data)?.path)} />
                                    }
                                    {
                                      JSON.parse(data).event === "security report download button" &&
                                      <CustomButton label="Download Security Report Zip" onClick={() => handleDownload(JSON.parse(data)?.path)} />
                                    }
                                  </>
                                  : <div className="mb-2 me-2 badge-pill text-wrap">{data}</div>
                              }
                            </Col>
                          )): <div className="mb-2 me-2 badge-pill text-wrap">Processing... Please wait...</div>}
                        </Row>
                        {
                          upgradeDetails != {} && 
                          <Row className="mt-5">
                            <Col className="text-end">
                              <CustomButton className="me-3" label="Fix Security Vulnerabilities" onClick={() => {
                                handleVulnerabilities()
                                const updatedStep = steps.map(step => {
                                  if(step.key === "step3"){
                                    return {
                                      ...step,
                                      status: "completed",
                                    }
                                  } else {
                                    return step
                                  }
                                })
                                setSteps(updatedStep)
                                setActiveStep(3)
                              }} />
                            </Col>
                          </Row>
                        }
                      </Container>
                    }
                    {
                      activeStep == 3 &&
                      <Container className="px-4 py-3">
                        <Row>
                          {vulnerabilityData.length > 0 ? vulnerabilityData.map((data, index) => (
                            <Col md={12} key={index}>
                              {
                                data.includes("event") && data.includes("path") ?
                                  <>
                                    {
                                      JSON.parse(data)?.event === "new security report download button" &&
                                      <CustomButton className="mb-2" label="Download Security Report Zip" onClick={() => handleDownload(JSON.parse(data)?.path)} />
                                    }
                                    {
                                      JSON.parse(data).event === "new upgraded project download button" &&
                                      <CustomButton label="Download new Project Zip" onClick={() => handleDownload(JSON.parse(data)?.path)} />
                                    }
                                  </>
                                  : <div className="mb-2 me-2 badge-pill text-wrap">{data}</div>
                              }
                              {/* <div className="mb-2 me-2 badge-pill text-wrap">{data}</div> */}
                            </Col>
                          )) : <div className="mb-2 me-2 badge-pill text-wrap">Processing... Please wait...</div>}
                        </Row>
                        <Row className="mt-5">
                          <Col className="text-end">
                            {vulnerabilityDetails != {} && 
                            <>
                              <CustomButton className="me-3" label="Unit Testing" onClick={() => {
                                const updatedStep = steps.map(step => {
                                  if(step.key === "step2"){
                                    return {
                                      ...step,
                                      status: "completed",
                                    }
                                  } else {
                                    return step
                                  }
                                })
                                setSteps(updatedStep)
                                setActiveStep(4)
                              }} />
                            </>
                            }
                          </Col>
                        </Row>
                      </Container>
                    }
                    {
                      activeStep == 4 && <div>Development In Progress</div>
                    }
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default VersionUpgrade;